<template>
    <div class="finish-downgrade">
        <div class="finish-downgrade-container">
            <div class="image">
                <slot name="image" />
            </div>
            <div class="content">
               <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {

    props: {
        name: {
            type: String,
            default: '',
        },
    },

    /**
     * Unmounted hook
     */
    destroyed() {
        this.resetScreenState();
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Reset screen UIState
         */
        resetScreenState() {
            this.changeUIState({ [`is${this.name}View`]: false });
        },
    },
};
</script>
